<template>
  <div class="Select__arrow">
    <svg width="11" height="7" viewBox="0 0 10.64 6.73">
      <path d="M1,1,5.32,5.32,9.64,1"/>
    </svg>
  </div>
</template>
